export const SUBSCRIPTION_TIERS = {
    STARTER: "starter",
    PRO: "pro",
    ENTERPRISE: "enterprise",
};

const LEGACY_TIER_MAP = {
    standard: SUBSCRIPTION_TIERS.STARTER,
    premium: SUBSCRIPTION_TIERS.PRO,
};

const TIER_LABELS = {
    [SUBSCRIPTION_TIERS.STARTER]: "Starter",
    [SUBSCRIPTION_TIERS.PRO]: "Pro",
    [SUBSCRIPTION_TIERS.ENTERPRISE]: "Enterprise",
};

const toFiniteNumber = (value) => {
    const numberValue = Number(value);

    return Number.isFinite(numberValue) ? numberValue : null;
};

export const normalizeTierName = (tierName) => {
    const normalizedTier = String(tierName || "")
        .trim()
        .toLowerCase();

    if (LEGACY_TIER_MAP[normalizedTier]) {
        return LEGACY_TIER_MAP[normalizedTier];
    }

    if (Object.values(SUBSCRIPTION_TIERS).includes(normalizedTier)) {
        return normalizedTier;
    }

    return SUBSCRIPTION_TIERS.STARTER;
};

export const SUBSCRIPTION_PLAN_LIMITS = {
    [SUBSCRIPTION_TIERS.STARTER]: {
        leadsPerSearch: 50,
    },
    [SUBSCRIPTION_TIERS.PRO]: {
        leadsPerSearch: 50,
    },
    [SUBSCRIPTION_TIERS.ENTERPRISE]: {
        leadsPerSearch: 50,
    },
};

export const getPlanLeadsPerSearch = (tierName) =>
    SUBSCRIPTION_PLAN_LIMITS[normalizeTierName(tierName)].leadsPerSearch;

export const getTierName = (credits, fallbackTierName) =>
    normalizeTierName(credits?.tier_name || fallbackTierName);

export const getTierLabel = (tierName) =>
    TIER_LABELS[normalizeTierName(tierName)];

export const getCreditUsage = ({ used, limit, remaining }) => {
    const usedValue = toFiniteNumber(used) || 0;
    const limitValue = toFiniteNumber(limit);
    const remainingValue = toFiniteNumber(remaining);

    if (remainingValue !== null) {
        return {
            used: usedValue,
            limit: limitValue,
            remaining: Math.max(remainingValue, 0),
            isUnlimited: false,
        };
    }

    if (limitValue !== null) {
        return {
            used: usedValue,
            limit: limitValue,
            remaining: Math.max(limitValue - usedValue, 0),
            isUnlimited: false,
        };
    }

    return {
        used: usedValue,
        limit: null,
        remaining: null,
        isUnlimited: true,
    };
};

export const hasAvailableCredits = (creditUsage) =>
    creditUsage?.isUnlimited || (creditUsage?.remaining ?? 0) > 0;

export const formatCreditValue = (value, unlimitedLabel = "Unlimited") => {
    if (value === null || value === undefined) {
        return unlimitedLabel;
    }

    const numberValue = Number(value);

    return Number.isFinite(numberValue)
        ? numberValue.toLocaleString()
        : unlimitedLabel;
};
